export default __webpack_public_path__ + "static/media/IconCross.7397b2f4.png";